import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import httpCommon from "../../utils/httpCommon";

const initialState = {
    loading: false,
    payments: [],
    banks: [],
    users: [],
    status: [],
    error: ''
}

export const fetchPayments = createAsyncThunk('fetchPayments', async () => {

    return await httpCommon.get('/payment/list')
        .then((response) => {
            console.log(response.data)
            return response.data
        })
})

export const filterPayments = createAsyncThunk('filterPayments', async (filter: any) => {

    return await httpCommon.get('/payment/list/search', { params: filter })
        .then((response) => {
            return response.data
        })
})

const paymentListReducer = createSlice({
    name: 'paymentList',
    initialState,
    reducers: {},
    extraReducers: (builder) => {

        builder
            .addCase(fetchPayments.pending, (state, action) => {
                state.loading = true
            })
            .addCase(fetchPayments.fulfilled, (state, action) => {
                state.loading = false
                state.payments = action.payload.payments
                state.banks = action.payload.banks
                state.users = action.payload.users
                state.status = action.payload.status
                state.error = ''
            })
            .addCase(fetchPayments.rejected, (state, action) => {
                state.loading = false
                state.payments = []
                state.error = action.error.message!.toString()
            })

        builder
            .addCase(filterPayments.pending, (state, action) => {
                state.loading = true
            })
            .addCase(filterPayments.fulfilled, (state, action) => {
                state.loading = false
                state.payments = action.payload
                state.error = ''
            })
            .addCase(filterPayments.rejected, (state, action) => {
                state.loading = false
                state.payments = []
                state.error = action.error.message!.toString()
            })
    }
})

export default paymentListReducer.reducer;